import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {AppDeviceService} from "../app-device.service";
import {ContentMessageComponent} from "../../notification/message/content-message.component";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {NotificationService} from "../../notification/notification.service";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonComponent} from '../../buttons/button/button.component';
import {Page} from '../../navigation/page';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';

@Component({
    selector: "woa-app-device-status-page",
    templateUrl: "./app-device-status-page.component.html",
    styleUrl: "./app-device-status-page.component.scss",
    providers: [{provide: Page, useExisting: AppDeviceStatusPageComponent}],
    imports: [
        ButtonComponent,
        ContentMessageComponent,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDeviceStatusPageComponent extends Page {
    public appDeviceService: AppDeviceService = inject(AppDeviceService);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);
    private notificationService: NotificationService = inject(NotificationService);

    MessageLevel = MessageLevel;

    sendStatus(): void {
        this.notificationService.logInfoToServer("App Device Status Logs:  Client ID = " + this.configurationModel.clientId() + "   |   " + this.appDeviceService.appDeviceStatusSummary);
        this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.SUCCESS, "woa.message.app-device-status.statusSent"));
        void this.dismiss();
    }
}
